"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const ComboBoxContext = createContext({
  value: null,
  onValueChange: () => {
  },
  /* FIXME: strictNullCheck temporary fix */
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'DataSchema ... Remove this comment to see the full error message
  schema: null,
  /* FIXME: strictNullCheck temporary fix */
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IValueSpec ... Remove this comment to see the full error message
  valueSpec: null,
  variablesSchema: null,
  /* FIXME: strictNullCheck temporary fix */
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IComboBoxOp... Remove this comment to see the full error message
  options: null,
  /* FIXME: strictNullCheck temporary fix */
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IComboBoxOp... Remove this comment to see the full error message
  optionFactories: null,
  allowCustom: false,
  isDropdownOpen: false,
  openDropdown: () => {
  },
  closeDropdown: () => {
  }
});
ComboBoxContext.displayName = "ComboBoxOptionsContext";
function useComboBox() {
  return useContext(ComboBoxContext);
}

export { ComboBoxContext, useComboBox };
